// Route Code Edited 06/30/2026
/* 
 * Route YMQ Draft Order Fix
 * 
 * YMQ intercepts the checkout button and creates a draft order via its own
 * backend, bypassing Route's cart add. This script:
 * 1. Patches fetch to capture Route's variant/price data from cart/add.js
 * 2. Intercepts Route's programmatic click on the original checkout button
 *    before YMQ's span wrapper handler fires
 * 3. Injects Route as a line item via YMQ's ymqOptionCheckoutLineItems hook
 * 4. Re-clicks the original button so YMQ proceeds normally with Route included
 *
 * Load without defer/async before </head> in theme.liquid:
 * <!-- Route Code Edited 6/__/26 -->
 * <script src="{{ 'route-ymq-draft-order-fix.js' | asset_url }}"></script>
 * <!-- End Route Code -->
**/ 

(function () {
  let checkoutInitiated = false;
  let routeLineItem = null;
  let pendingBtn = null;
  let pendingBtnTimer = null;
  const MAX_MS = 5000;
  const _fetch = window.fetch;
 
  // ─── PART 1: Patch fetch early to capture Route's add.js response ───────
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const promise = _fetch.apply(this, args);
 
    if (url.includes('cart/add.js')) {
      promise.then(async (res) => {
        if (!checkoutInitiated) return;
        let body = null;
        try { body = await res.clone().json(); } catch (e) {}
 
        // cart/add.js returns either a single item object or { items: [...] }
        const items = Array.isArray(body?.items) ? body.items : (body?.handle ? [body] : []);
        const routeItem = items.find(i => i.handle === 'routeins');
 
        if (routeItem) {
          routeLineItem = {
            variantId: `gid://shopify/ProductVariant/${routeItem.variant_id}`,
            quantity: routeItem.quantity || 1,
            priceOverride: {
              amount: routeItem.presentment_price,
              currencyCode: window.Shopify?.currency?.active || 'USD'
            },
            customAttributes: Object.entries(routeItem.properties || {})
              .filter(([k]) => !['_YmqItemPrice', '_YmqItemPriceOneTime', '_YmqOneTimeInfo',
                                  '_YmqItemSku', '_YmqItemWeight', '__ymq_option_info'].includes(k))
              .map(([key, value]) => ({ key, value: String(value) }))
          };
 
          // If the button click arrived before our async parse completed, fire now
          if (pendingBtn) {
            const btn = pendingBtn;
            pendingBtn = null;
            fireWithRoute(btn);
          }
        }
      }).catch(() => {});
    }
 
    return promise;
  };
 
  function fireWithRoute(btn) {
    clearTimeout(pendingBtnTimer);
    pendingBtnTimer = null;

    const capturedRouteLineItem = routeLineItem;  // snapshot of the value for closure
    routeLineItem = null;                         // outer variable cleared
    checkoutInitiated = false;
 
    // One-shot hook — YMQ calls this immediately before building the draft order payload
    window.ymqOptionCheckoutLineItems = function (lineItems) {
      window.ymqOptionCheckoutLineItems = null;
      try {
        if (!capturedRouteLineItem) return lineItems;
        const alreadyIncluded = lineItems.some(item => {
          const numericId = item.variantId?.split('/').pop();
          const cartItem = window.ymqOption?.cart?.items?.find(
            c => String(c.variant_id) === numericId
          );
          return cartItem?.handle === 'routeins';
        });
        return alreadyIncluded ? lineItems : [...lineItems, capturedRouteLineItem];
      } catch (e) {
        return lineItems;
      }
    };

    // setTimeout escapes the Promise microtask chain — btn.click() from
    // a .then() callback doesn't trigger navigation on iOS WebKit
    setTimeout(() => btn.click(), 0);
  }
 
  // ─── PART 2: Intercept Route's programmatic click on the original button ─
  document.addEventListener('DOMContentLoaded', function () {
    const ROUTE_BTN = '[data-route-cloned-button]';
 
    const s = document.querySelector('script[src*="shopify.widget.js"][src*="entrypoints"]');
    const ORIGINAL_BTN_BASE = (s
      ? new URL(s.src).searchParams.get('entrypoints[0].checkoutSelector')
      : null) ?? '[data-original-display]';
 
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        checkoutInitiated = false;
        routeLineItem = null;
        pendingBtn = null;
        clearTimeout(pendingBtnTimer);
        pendingBtnTimer = null;
        window.ymqOptionCheckoutLineItems = null;
      }
    });
 
    // Track when Route's cloned button is clicked
    document.addEventListener('click', function (e) {
      if (!e.target.closest(ROUTE_BTN) || checkoutInitiated) return;
      checkoutInitiated = true;
    }, true);
 
    // Intercept the original checkout button click in capture phase —
    // this fires before YMQ's span wrapper stopImmediatePropagation
    document.addEventListener('click', function (e) {
      if (!checkoutInitiated) return;
 
      // Identify the original checkout button, exclude Route's own elements
      const btn = e.target.closest(ORIGINAL_BTN_BASE);
      if (!btn) return;
      if (e.target.closest('[data-route-widget]')) return;
      if (e.target.closest(ROUTE_BTN)) return;
 
      e.stopImmediatePropagation();
      e.preventDefault();
 
      if (routeLineItem) {
        // Route's add.js response already parsed — fire immediately
        fireWithRoute(btn);
        return;
      }
 
      // Route's add.js response hasn't arrived yet (async json() yielded first)
      // Store the button and wait; fireWithRoute will be called from Part 1
      pendingBtn = btn;
 
      // Fallback: if Route's item never arrives (protection toggled off,
      // or Route not opted in), release the click without Route after MAX_MS
      pendingBtnTimer = setTimeout(() => {
        if (pendingBtn !== btn) return;
        pendingBtn = null;
        checkoutInitiated = false;
        btn.click();
      }, MAX_MS);
    }, true);
  });
 
})();
// End Route Code